import BuyerNdaCard from './BuyerNdaCard.component';

export default BuyerNdaCard;
